import React, { Fragment, useCallback, useEffect, useState } from "react";
import Label from "../../components/label";
import PropTypes from "prop-types";
import CustomModal from "../../components/modal";
import { getFormattedTimeWithTimeZoneCapital, getMomentObjFormatterWithTimeZone } from "../../utils/dateTimeHelper";
import AddShiftForm from "./AddShiftForm";
import InstaButton from "../../components/button";
import DropdownMultiCheckbox from "../../components/form/dropDownWithCheckbox";
import moment from "moment";
import { useFormik } from "formik";
import ICSelect from "../../components/form/selectInput";

const AssignedShiftLabels = ({ data, scheduleFilter, handleShiftLabelClick, timezone }) => {
  return (data.map((shift) => {
    return (<>
      {getShiftColors(shift, scheduleFilter)
        .map(color => renderShiftWithColor(shift, handleShiftLabelClick, color, timezone))}
    </>);
  }));
};

function renderShiftWithColor(shift, handleShiftLabelClick, color, timezone) {
  return (<div key={shift._id + color} className="assigned-shifts-labels-container mt-2" data-toggle="tooltip"
    data-placement="top" style={{ backgroundColor: color }}
    onClick={(e) => handleShiftLabelClick(e, shift)}>
    <span className={"badge " + color}>
      <p className="shift-person">{getShiftName(color)}</p> <br />
      <p className="shift-person">
        {shift.doctorId?.firstName} {shift.doctorId?.lastName}
      </p>
      <br />
      <p
        className="shift-end-time">{getFormattedTimeWithTimeZoneCapital(shift.shiftStartTime, timezone)} to {getFormattedTimeWithTimeZoneCapital(shift.shiftEndTime, timezone)}</p>
    </span>
  </div>);
}

function getShiftName(color) {
  if (color === "bg-instant-switch") return "Instant Switch";
  if (color === "bg-instant-leaf") return "Instant Leaf";
  if (color === "bg-instant-hush") return "Instant Hush";

  return "Shift";
}

function getShiftColors(shift, scheduleFilter) {
  const colors = [];
  const allowAll = !scheduleFilter || !scheduleFilter.length;

  if (shift.shiftFor === "INSTANT_SWITCH" && (allowAll || scheduleFilter?.some(filter => filter.value === "Smoking Cessation"))) colors.push("bg-instant-switch");
  if (shift.shiftFor === "INSTANT_LEAF" && (allowAll || scheduleFilter?.some(filter => filter.value === "Medicinal Cannabis"))) colors.push("bg-instant-leaf");
  if (shift.shiftFor === "INSTANT_HUSH" && (allowAll || scheduleFilter?.some(filter => filter.value === "Instant Hush"))) colors.push("bg-instant-hush");

  return colors;
}

const CalendarUI = props => {
  const formik = useFormik({
    initialValues: {
      timezone: "Australia/Brisbane"
    }
  });

  const DAY_OF_WEEKS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  const [doctorList, setDoctorList] = useState([]);
  const [valuesForDoctorFilter, setValuesForDoctorFilter] = useState([]);
  const [filter, setFilter] = useState({});
  const [selectedDay, setSelectedDay] = useState(null);
  const [dataToEdit, setDataToEdit] = useState(null);
  const [isOpenAddShiftModal, setIsOpenAddShiftModal] = useState(false);
  const [currentTimezone, setCurrentTimezone] = useState("Australia/Brisbane");
  const [shiftsByDate, setShiftsByDate] = useState(props.shiftsByDate)
  console.log("props.shiftsByDate : ", props.shiftsByDate)
  const timeZoneList = [
    {
      val: "Australia/Sydney", _id: "Australia/Sydney"
    },
    {
      val: "Australia/Melbourne", _id: "Australia/Melbourne"
    },
    {
      val: "Australia/Brisbane", _id: "Australia/Brisbane"
    },
    {
      val: "Australia/Perth", _id: "Australia/Perth"
    },
    {
      val: "Australia/Adelaide", _id: "Australia/Adelaide"
    },
    {
      val: "Australia/Darwin", _id: "Australia/Darwin"
    }
  ]
  const openDoctorSchedulePopup = (data) => {
    setDataToEdit(null);
    const date = getMomentObjFormatterWithTimeZone(data.date, "DD/MM/YYYY");
    setSelectedDay(date);
    setIsOpenAddShiftModal(true);
  };

  const closeAddShiftModal = () => {
    setIsOpenAddShiftModal(false);
    setSelectedDay(null);
  };

  const changeTimezone = (value) => {
    console.log(value)
    setCurrentTimezone(value)
  };

  const handleShiftLabelClick = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    setDataToEdit({
      ...data,
      doctorId: data.doctorId._id,
      doctorName: `${data.doctorId.firstName} ${data.doctorId.lastName}`,
    });

    const date = getMomentObjFormatterWithTimeZone(data.shiftDate, "DD/MM/YYYY");
    setSelectedDay(date);
    setIsOpenAddShiftModal(true);
  };

  const handleOnChangeDoctorFilter = useCallback(val => {
    setValuesForDoctorFilter(val);
    const doctorIds = [];
    val.forEach((doctor, index) => {
      doctorIds.push(doctor._id);
    });

    const currentFilter = { ...filter, doctorIds };
    setFilter(currentFilter);
    props.handleFilterChange(currentFilter);
  }, []);

  useEffect(() => {
    const doctors = props.doctorList.map((doctor, index) => ({
      ...doctor, title: `${doctor.firstName} ${doctor.lastName}`
    }));
    console.log("Doctors: ", doctors);
    setDoctorList(doctors);
    setValuesForDoctorFilter(doctors);
  }, [props.doctorList]);

  useEffect(() => {
    Object.keys(shiftsByDate).forEach(date => {
      shiftsByDate[date].forEach(shift => {
        const shiftStartTimeUTC = new Date(shift.shiftStartTime);
        const shiftEndTimeUTC = new Date(shift.shiftEndTime);

        // Use the Intl.DateTimeFormat API for accurate time zone conversion
        const options = { timeZone: currentTimezone, hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };

        shift.shiftStartTimeLocal = new Intl.DateTimeFormat('en-US', options).format(shiftStartTimeUTC);
        shift.shiftEndTimeLocal = new Intl.DateTimeFormat('en-US', options).format(shiftEndTimeUTC);
        // shift.shiftStartTimeLocal = new Date(shift.shiftStartTime).toLocaleString('en-US', { timeZone: currentTimezone });
        // shift.shiftEndTimeLocal = new Date(shift.shiftEndTime).toLocaleString('en-US', { timeZone: currentTimezone });
      });
    });
    setShiftsByDate(props.shiftsByDate)
    console.log('props.shiftsByDate : ', props.shiftsByDate)
  }, [changeTimezone]);
  useEffect(() => {
    console.log("setShiftsByDate :", shiftsByDate)
  }, [shiftsByDate])

  // used below "handleFormSubmitCounter" for only closing the form after API completed successfully
  useEffect(() => {
    if (props.handleFormSubmitCounter) {
      console.log("Close the form now");
      closeAddShiftModal();
    }
  }, [props.handleFormSubmitCounter]);

  return (<>
    <div className="row p-0 m-0 head-clinic-list mb-3">
      <div className="col-sm-12 pl-0 pt-4">
        <Label title={"Doctors "} className={"w-100 ml-2 mb-0"} />
        <DropdownMultiCheckbox
          className="min-w-200"
          placeholder=""
          onChange={handleOnChangeDoctorFilter}
          value={valuesForDoctorFilter}
          optionList={doctorList}
          isMultiple={true}
        />
      </div>
    </div>

    <div className="row p-0 m-0 month-buttons mt-4 w-100">
      <div className="text-left row w-100 ml-1 mr-4">
        <InstaButton title="Previous" clickEvent={() => props.getPreviousMonthCalender(filter)} />
        <InstaButton className="ml-2" title="Next" clickEvent={() => props.getNextMonthCalender(filter)} />
        <div className="flex-fill"></div>

        <Label title={"My Timezone "} className={"mr-2 mt-2 mb-0"} />
        <ICSelect
          label="" className={"w-50"}
          id="timezone"
          name="timezone"
          placeholder=""
          useId="_id"
          render={val => `${val._id}`}
          isCombined={true}
          items={timeZoneList}
          onChange={val => setCurrentTimezone(val)}
          handleChange={val => {
            formik.handleChange("timezone");
            setCurrentTimezone(val);
            formik.setFieldValue("timezone", val);
          }}
          onBlur={formik.handleBlur}
          value={formik.values.timezone}
        />
        {/* <Label title={" " + new Date().toLocaleTimeString()} className={"mr-2 mt-2 mb-0"} /> */}
        <InstaButton className="insta-button-primary small border-radius-0 m-0 ml-4" title="Add Shift"
          clickEvent={() => openDoctorSchedulePopup({
            date: moment().add(1, "d").format('DD/MM/YYYY')
          })}
        />
      </div>
    </div>

    <div className="row p-0 m-0 calendar-container mt-4">
      {DAY_OF_WEEKS.map((day, index) => {
        return (<div key={index} className="calendar-day-of-week-column">
          <Label title={day} className="w-100 text-center secondary-font m-0" />
        </div>);
      })}
      {props.calendarDates.map((week, index) => {
        return week.map((day, dayIndex) => {
          return (<div key={`${index}-${dayIndex}`} className="calendar-column cursor-pointer"
            onClick={() => openDoctorSchedulePopup(day)}>
            <Label title={day.date} className="w-100 text-center" />
            {shiftsByDate[day.date] &&
              <AssignedShiftLabels data={shiftsByDate[day.date]} scheduleFilter={props.scheduleFilter}
                handleShiftLabelClick={(e, data) => handleShiftLabelClick(e, data)} timezone={currentTimezone} />}
          </div>);
        });
      })}
    </div>
    <CustomModal
      openModal={isOpenAddShiftModal}
      title={dataToEdit ? "Edit Shift" : "Add Shift"}
      noFooterButtons={true}
      size="lg"
      backdrop={false}
      cancelEvent={() => closeAddShiftModal()}
      modalBodyContent={<AddShiftForm
        onFormSubmit={(formData) => {
          props.handleShiftFormSubmit(formData, !!dataToEdit);
        }}
        dataToEdit={dataToEdit}
        timeZone={currentTimezone}
        selectedDay={selectedDay}
        doctorList={doctorList}
        deleteShift={() => {
          closeAddShiftModal();
          props.deleteShift(dataToEdit._id);
        }}
      />}
    />
  </>);
};

export default CalendarUI;

CalendarUI.defaultProps = {
  calendarDates: []
};

CalendarUI.propTypes = {
  calendarDates: PropTypes.array
};
